import clsx from 'clsx';
import React from 'react';

type Props = {
  type: string;
  value: string;
  theme?: 'blue' | 'green' | 'default' | 'navy';
};

export default function OverviewCard({
  type,
  value,
  theme = 'default',
}: Props) {
  const tagStyle = clsx(
    'block w-2 rounded-sm',
    theme == 'default' &&
      'bg-[rgba(255,225,225,1)] border border-[rgba(255,225,225,1)]',
    theme == 'blue' && 'bg-blue-950 border border-blue-950',
    theme == 'green' &&
      'bg-[rgba(162,242,238,1)] border border-[rgba(162,242,238,1)]',
    theme == 'navy' &&
      'bg-[rgba(27,99,146,1)] border border-[rgba(27,99,146,1)]'
  );
  return (
    <div className="p-4 sm:px-6 sm:py-4 bg-white shadow-sm rounded-md flex items-stretch gap-4">
      <span className={tagStyle}></span>
      <div className="space-y-2 flex-1">
        <p className="medium-emphasis-text  capitalize">{type}</p>
        <h5 className="font-semibold high-emphasis-text text-nowrap">
          <span>{value}</span>
          {type == 'reviews' && <span>⭐</span>}
        </h5>
      </div>
    </div>
  );
}
